import { useState, useEffect } from 'react';

const useReminderState = (allReminders, selectedPatient) => {
  const [filteredReminders, setFilteredReminders] = useState(
    selectedPatient
      ? allReminders.filter((reminder) => reminder.id === selectedPatient)
      : allReminders
  );
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [reminderToDelete, setReminderToDelete] = useState(null);
  const [patientIdToDelete, setPatientIdToDelete] = useState(null);

  // Update filtered reminders when allReminders or selectedPatient changes
  useEffect(() => {
    setFilteredReminders(
      selectedPatient
        ? allReminders?.filter((reminder) => reminder.id === selectedPatient)
        : allReminders
    );
  }, [allReminders, selectedPatient]);

  return {
    filteredReminders,
    setFilteredReminders,
    openDeleteDialog,
    setOpenDeleteDialog,
    reminderToDelete,
    setReminderToDelete,
    patientIdToDelete,
    setPatientIdToDelete,
  };
};

export default useReminderState;
